var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotStatistic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 101,
    height: 101,
    transform: "translate(150 290)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mascot_statistic",
    transform: "translate(-150 -290)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(8 -8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 27,
    cy: 8,
    rx: 27,
    ry: 8,
    transform: "translate(162 383)",
    fill: "#e5edf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(171.314 298.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21693",
    "data-name": "Path 21693",
    d: "M22.393,7.193a1.785,1.785,0,0,1-.231-.88,1.9,1.9,0,0,1,.055-.442L23.386.927,18.967,2.336,19.517,0,14.681,1.542A7.033,7.033,0,0,0,9.906,7.835a33.276,33.276,0,0,0-13,58.19c-1.425,1.128-12.58,6.12-15.168,9.465s-2.255,4.384-1.525,7.242,2.859,3.526,6,3.526S-2.894,78.885-2.894,79.4a5.168,5.168,0,0,0,.679,2.6,5.432,5.432,0,0,0,3.361,2.482,7.8,7.8,0,0,0,2.488.2c-.009.162-.037.33-.037.49a7.456,7.456,0,0,0,.241,1.926,5.436,5.436,0,0,0,2.483,3.363,5.433,5.433,0,0,0,4.154.469,7.748,7.748,0,0,0,2.249-1.049,7.725,7.725,0,0,0,1.389,1.969,5.432,5.432,0,0,0,3.832,1.67,6,6,0,0,0,5.272-3.693,7.724,7.724,0,0,0,2.17,1,5.23,5.23,0,0,0,6.635-3.832,7.449,7.449,0,0,0,.241-1.926c0-.183-.03-.375-.042-.562a7.763,7.763,0,0,0,2.418-.2A5.434,5.434,0,0,0,38,81.811a5.149,5.149,0,0,0,.69-2.6c0-1.261.051-5.277-2.311-8.5,5.261-.537,21.269-9.763,27.982-16.228S72.1,44.347,71.437,41.728s-7.05-4.73-9.5-3.278c-2.553.53-6.618,5.1-10.161,9.984s-5.141,6.051-5.141,6.051a30.116,30.116,0,0,0,4.494-14.321A33.278,33.278,0,0,0,22.393,7.193",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21694",
    "data-name": "Path 21694",
    d: "M72.824,71.11A30.412,30.412,0,1,1,42.412,40.7,30.412,30.412,0,0,1,72.824,71.11",
    transform: "translate(-24.571 -30.946)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21695",
    "data-name": "Path 21695",
    d: "M58.816,125.47a13.28,13.28,0,1,1-13.28-13.28,13.281,13.281,0,0,1,13.28,13.28",
    transform: "translate(-39.972 -85.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21696",
    "data-name": "Path 21696",
    d: "M68.585,139.677c0,4.86-.083,7.418-3.664,7.418-1.54,0-5.133-3.016-6.647-3.943-1.864-1.14-2.656-.705-2.656-3.475,0-4.861,2.9-8.8,6.484-8.8s6.484,3.942,6.484,8.8",
    transform: "translate(-57.736 -99.514)",
    fill: "#8dd7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21697",
    "data-name": "Path 21697",
    d: "M74.9,152.2c0,2.681-1.6,4.855-3.576,4.855s-3.577-2.174-3.577-4.855,1.6-4.855,3.577-4.855S74.9,149.519,74.9,152.2",
    transform: "translate(-66.96 -112.038)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21698",
    "data-name": "Path 21698",
    d: "M70.282,147.577c0,.847-.506,1.534-1.13,1.534s-1.131-.688-1.131-1.534.506-1.535,1.131-1.535,1.13.688,1.13,1.535",
    transform: "translate(-67.167 -111.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21699",
    "data-name": "Path 21699",
    d: "M76.646,161.891a.689.689,0,1,1-.688-.689.688.688,0,0,1,.688.689",
    transform: "translate(-72.678 -122.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21700",
    "data-name": "Path 21700",
    d: "M161.288,125.47a13.28,13.28,0,1,1-13.28-13.28,13.281,13.281,0,0,1,13.28,13.28",
    transform: "translate(-117.888 -85.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21701",
    "data-name": "Path 21701",
    d: "M181.057,139.677c0,2.231-2.492,2.319-3.538,3.929-1.149,1.769-3.367,3.978-5.3,3.978-3.581,0-4.125-3.047-4.125-7.907s2.9-8.8,6.484-8.8,6.483,3.942,6.483,8.8",
    transform: "translate(-143.256 -99.514)",
    fill: "#8dd7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21702",
    "data-name": "Path 21702",
    d: "M187.373,152.2c0,2.681-1.6,4.855-3.576,4.855s-3.577-2.174-3.577-4.855,1.6-4.855,3.577-4.855,3.576,2.173,3.576,4.855",
    transform: "translate(-152.479 -112.038)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21703",
    "data-name": "Path 21703",
    d: "M182.754,147.577c0,.847-.505,1.534-1.13,1.534s-1.131-.688-1.131-1.534.507-1.535,1.131-1.535,1.13.688,1.13,1.535",
    transform: "translate(-152.686 -111.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21704",
    "data-name": "Path 21704",
    d: "M189.118,161.891a.689.689,0,1,1-.688-.689.688.688,0,0,1,.688.689",
    transform: "translate(-158.198 -122.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21705",
    "data-name": "Path 21705",
    d: "M59.594,285.387c-3.244,0-5.582-.815-5.582-2.753s2.63-3.51,5.874-3.51,14.471,1.572,14.471,3.51-7.843,1.308-11.088,1.308",
    transform: "translate(-56.515 -212.236)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21706",
    "data-name": "Path 21706",
    d: "M70.763,302.006c-2.81,1.622-5.873,1.576-6.842-.1s-1.006-5.837,3.349-7.833,13.3-4.018,14.27-2.339-7.967,8.653-10.777,10.276",
    transform: "translate(-63.646 -221.348)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21707",
    "data-name": "Path 21707",
    d: "M98.724,307.606c-1.622,2.81-4.3,4.3-5.976,3.333s-1.726-4.033-.1-6.842,8.6-11.746,10.275-10.777-2.573,11.478-4.2,14.287",
    transform: "translate(-84.987 -222.975)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21708",
    "data-name": "Path 21708",
    d: "M131.72,307.8c0,3.244-1.572,5.874-3.51,5.874s-3.511-2.63-3.511-5.874,1.572-14.471,3.51-14.47,3.51,11.225,3.51,14.47",
    transform: "translate(-110.263 -223.042)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21709",
    "data-name": "Path 21709",
    d: "M148.341,303.66c1.622,2.81,1.576,5.873-.1,6.842s-4.355-.522-5.977-3.331-5.875-13.318-4.2-14.287,8.653,7.966,10.275,10.776",
    transform: "translate(-120.133 -222.644)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21710",
    "data-name": "Path 21710",
    d: "M155.48,289.077c1.5,1.879,2.005,5.942,1.036,7.621s-4.033,1.725-6.842.1-11.746-8.6-10.776-10.275,11.477-2.881,14.287-1.259",
    transform: "translate(-121.003 -216.324)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21711",
    "data-name": "Path 21711",
    d: "M184.535,168.249c3.244,0,5.315.937,5.874,3.51s-4.316,6.984-4.316,6.984-12.54,12.392-23.266,15.772c-12.081,3.807-23.914,4.633-23.914,3.6,0-1.194,14.705-6.978,27.452-13.157,7.908-3.834,12.924-16.38,18.17-16.713",
    transform: "translate(-121.07 -127.932)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21717",
    "data-name": "Path 21717",
    d: "M4.269,26.592c-2.34,0-3.834-.823-4.237-3.083s3.114-6.134,3.114-6.134S12.191,6.491,19.928,3.522C28.643.179,37.178-.547,37.178.357c0,1.049-11.639,5.451-19.763,12.166C11.71,15.89,8.054,26.3,4.269,26.592",
    transform: "translate(-11.613 57.015) rotate(16)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21712",
    "data-name": "Path 21712",
    d: "M120.27,19.207a5.815,5.815,0,0,1,.16-1.335A4.258,4.258,0,0,0,117.612,22a4.114,4.114,0,0,0,3.9,4.295,3.8,3.8,0,0,0,3.179-1.807,5.122,5.122,0,0,1-4.426-5.277",
    transform: "translate(-104.874 -13.59)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21713",
    "data-name": "Path 21713",
    d: "M137.968,22.849a4.76,4.76,0,0,1,.133-1.1,3.52,3.52,0,0,0-2.329,3.409A3.4,3.4,0,0,0,139,28.706a3.146,3.146,0,0,0,2.628-1.493,4.234,4.234,0,0,1-3.659-4.363",
    transform: "translate(-118.682 -16.536)",
    fill: "#00bcf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21714",
    "data-name": "Path 21714",
    d: "M132.259,185.115a5.418,5.418,0,1,1-5.418-5.464,5.441,5.441,0,0,1,5.418,5.464",
    transform: "translate(-110.226 -136.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21715",
    "data-name": "Path 21715",
    d: "M103.193,205.822a13.127,13.127,0,0,1,4.888-2.048c2.416-.349,3.267-.451,4.543.454,1.745,1.9-.715,5.432-3.589,8.173a11.186,11.186,0,0,1-15.436,0l-.2-.186c-2.861-2.706-3.131-4.8-3.18-5.388s.238-2.643,2.981-1.958,4.713,2.146,7.179,1.733S102.721,206.087,103.193,205.822Z",
    transform: "translate(-83.476 -154.84)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21716",
    "data-name": "Path 21716",
    d: "M126.111,235.623a11.191,11.191,0,0,1-11.782,0,6.907,6.907,0,0,1,11.782,0",
    transform: "translate(-102.378 -176.651)",
    fill: "#f6921e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 66.575,
    height: 93.513,
    transform: "translate(-15.446 -0.001)",
    fill: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotStatistic);
export default __webpack_public_path__ + "static/media/mascot_statistic.2e7ab042e4372747a948e472ab99c96c.svg";
export { ForwardRef as ReactComponent };